export default [
  "transparent",
  "#fff",
  "#bfbfbf",
  "#000",
  "#fffe55",
  "#ea3323",
  "#4faeea",
  "#9fce63",
];
